"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckAvailabilityResponseMapper = void 0;
var CheckAvailabilityResponseMapper = /** @class */ (function () {
    function CheckAvailabilityResponseMapper(data) {
        this.localData = data;
    }
    CheckAvailabilityResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return CheckAvailabilityResponseMapper;
}());
exports.CheckAvailabilityResponseMapper = CheckAvailabilityResponseMapper;
//# sourceMappingURL=CheckAvailabilityResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/CheckAvailabilityResponseMapper.js
// module id = 2211
// module chunks = 8